<template>
  <div class="cooperateShop">
    <view class="toptitle">
      <titleColor :title="asd" />
    </view>
    <view class="cooperateBottom">
      <view
        class="coopreateDetail"
        v-for="(item, index) in partnerList.slice(0, 8)"
        :key="item.pic"
        :class="{
          'choseType': choseId === index,
          'last-in-row': (index + 1) % 4 === 0,
          'in-last-row': index >= 4
      }">
        <img :src="item.pic" alt="" />
      </view>
    </view>
  </div>
</template>
<script>
import titleColor from '@/components/titleColor'
import { getSiteConfigDetail } from '@/apis/modules/Information/index'
import { getHost } from '@/utils/domain'
export default {
  components: {
    titleColor,
  },
  data() {
    return {
      choseId: 0,
      partnerList: [],
      asd: "精品合作·精选物流",
    };
  },
  mounted() {
    this.fetchPartnerList();
  },
  methods: {
    coopreateChose(id) {
      this.choseId = id;
    },
    async fetchPartnerList() {
      try {
        const res = await getSiteConfigDetail({ host: getHost() });
        if (
          res &&
          res.statusCode === 20000 &&
          res.data &&
          res.data.conf &&
          res.data.conf.introduction &&
          Array.isArray(res.data.conf.introduction.premiumPartner)
        ) {
          this.partnerList = res.data.conf.introduction.premiumPartner;
        }
      } catch (e) {
        this.partnerList = [];
      }
    }
  },
};
</script>
<style scoped lang="scss">
.cooperateShop {
  width: 1400px;
  margin-top: 24px;
  background: #FFFFFF;
  box-shadow: 0px 8px 48px 0px rgba(0, 23, 77, 0.1);
  padding: 24px;
  .toptitle{
    display: flex;
  }
  .cooperateBottom {
    flex-wrap: wrap;
    display: flex;
    margin-top: 12px;
    .coopreateDetail {
      width: 338px;
      height: 338px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-width: 0px 1px 1px 0px;
      border-style: solid;
      border-color: rgba(0, 27, 81, 0.1);
      img{
        display: block;
        margin: 0 auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
    .last-in-row {
      border-right-width: 0px;
    }
    .in-last-row {
      border-bottom-width: 0px;
    }
    .choseType{
      background: #FFFFFF;
      box-sizing: border-box;
      border: 0px solid rgba(0, 27, 81, 0.1);
      box-shadow: 0px 8px 48px 0px rgba(0, 23, 77, 0.1);
    }
  }
}
</style>
